import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const MentionsLegales = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-20 pb-12 bg-slate-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-lg shadow-lg p-8 lg:p-12">
              <h1 className="text-3xl font-bold text-slate-900 mb-8">
                Mentions Légales
              </h1>
              
              <div className="space-y-8 text-slate-600 leading-relaxed">
                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">1. Informations générales</h2>
                  <p>
                    Conformément aux dispositions des articles 6-III et 19 de la Loi n° 2004-575 du 21 juin 2004 
                    pour la Confiance dans l'économie numérique, dite L.C.E.N., nous portons à la connaissance 
                    des utilisateurs et visiteurs du site les informations suivantes :
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">2. Éditeur du site</h2>
                  <div className="bg-slate-50 p-6 rounded-lg">
                    <p>
                      <strong>Raison sociale :</strong> SHADOWTACT SARL<br />
                      <strong>Forme juridique :</strong> EURL - Entreprise Unipersonnelle à Responsabilité Limitée<br />
                      <strong>Siège social :</strong> 5, Allée de la Grande Treille, 35200 Rennes, France<br />
                      <strong>Téléphone :</strong> 01 85 09 91 73 <br />
                      <strong>Email :</strong> info@shadowtact.fr<br />
                      <strong>SIREN :</strong> 919 227 488<br />
                      <strong>SIRET :</strong> 919 227 488 00013<br />
                      <strong>RCS :</strong> Rennes 919 227 488<br />
                      <strong>Numéro de TVA intracommunautaire :</strong> FR24919227488<br />
                      <strong>Code APE/NAF :</strong> 4791B - Vente à distance sur catalogue spécialisé
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">3. Directeur de la publication</h2>
                  <p>
                    Le directeur de la publication du site est le représentant légal de SHADOWTACT SARL.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">4. Hébergeur du site</h2>
                  <p>
                    Le site est hébergé par :<br />
                    <strong>IONOS SARL</strong><br />
                    Adresse : 7, place de la Gare – BP 70109 – 57200 Sarreguemines – France<br />
                    Téléphone : 09 70 80 89 11
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">5. Propriété intellectuelle</h2>
                  <p>
                    L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur 
                    et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour 
                    les documents téléchargeables et les représentations iconographiques et photographiques.
                  </p>
                  <p className="mt-4">
                    La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est 
                    formellement interdite sauf autorisation expresse de SHADOWTACT SARL.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">6. Protection des données personnelles</h2>
                  <p>
                    En application du Règlement Général sur la Protection des Données (RGPD) et de la loi 
                    "Informatique et Libertés", les utilisateurs du site disposent des droits suivants :
                  </p>
                  <ul className="list-disc list-inside mt-2 ml-4 space-y-1">
                    <li>Droit d'accès aux données personnelles</li>
                    <li>Droit de rectification des données personnelles</li>
                    <li>Droit à l'effacement des données personnelles</li>
                    <li>Droit à la portabilité des données</li>
                    <li>Droit d'opposition au traitement des données</li>
                  </ul>
                  <p className="mt-4">
                    Pour exercer ces droits, vous pouvez nous contacter à l'adresse : 
                    5, Allée de la Grande Treille, 35200 Rennes ou par téléphone au 01 85 09 91 73.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">7. Cookies et traceurs</h2>
                  <p>
                    Le site peut utiliser des cookies techniques nécessaires à la navigation et au bon fonctionnement 
                    des services. Ces cookies ne nécessitent pas de consentement préalable. L'utilisateur peut 
                    configurer son navigateur pour refuser les cookies.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">8. Droit applicable</h2>
                  <p>
                    Le présent site et les présentes mentions légales sont régis par le droit français. 
                    Tout litige sera porté devant les tribunaux compétents de Rennes.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">9. Contact</h2>
                  <p>
                    Pour toute question concernant ces mentions légales ou le fonctionnement du site, 
                    vous pouvez nous contacter :
                  </p>
                  <div className="bg-emerald-50 p-4 rounded-lg mt-4">
                    <p>
                      <strong>SHADOWTACT SARL</strong><br />
                      5, Allée de la Grande Treille<br />
                      35200 Rennes<br />
                      info@shadowtact.fr<br />
                      <strong>Téléphone :</strong> 01 85 09 91 73
                    </p>
                  </div>
                </div>

                <div className="bg-slate-50 p-6 rounded-lg mt-8">
                  <p className="text-sm text-slate-500">
                    <strong>Dernière mise à jour :</strong> Janvier 2025
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MentionsLegales;